module.exports = fox => {
	const socketsReconnectMixin = require('../common/widget/mixin/socketsReconnect')(fox);

	const generateToken = (salt = 'random') => {
		const ua = navigator.userAgent;
		const now = new Date().getTime();
		const random = Math.random().toString().slice(2);

		return fox.getStringSimpleHash(fox.shuffle([ua, now, salt]).join(random), 16);
	}

	class AutoLoginService {
		constructor(context /* Controller */) {
			this.context = context;
			this.tokens = [];
		}

		injectToken(injectTo, salt) {
			const token = generateToken(salt);

			this.tokens.push(token);

			return {
				...injectTo,
				token
			}
		}

		matchToken(token) {
			return fox.inArray(this.tokens, token);
		}

		shouldAuthorize(token) {
			const api = this.context.getApi('__clientAuthorizer', { method: 'site.authorizer.authByToken' });
			const root = fox.wom.getRoot();
			const pm = root.wom1('#permissionManager');
			
			if (!this.matchToken(token))
				return fox.Promise.resolve(false);

			return api.psend({ token }).then(resp => {
				if (pm) {
					fox.setEnv('member', fox.objectGet(resp, 'params.answer.response'));

					const isPremium = pm.getMemberInfo('isPremium');
					const rules = {
						guest: {
							enabled: true
						}
					};

					if (!fox.isEmpty(isPremium)) {
						rules.guest.enabled = false;
						rules.member = {
							enabled: true
						}
					}
					
					const promise = pm.wait('@this', 'permissions_update', {
						prefix: `listener_for_${token}`
					}).then(() => this.reconnectSockets());

					pm.updatePermissions(rules);

					return promise;
				}

				return false;
			}).catch(e => {
				return false;
			});
		}
	}

	fox.mixin(AutoLoginService.prototype, socketsReconnectMixin);

	return AutoLoginService;
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/auto-login/index.es.js